import styled, { css } from 'styled-components';
import { media } from 'app/utils/style';
import { colors, breakpoints } from 'app/variables';

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  color: ${colors.pacificBlue};
  gap: 0.5rem;
  border: 1px solid;
  border-radius: 10px;
  overflow: auto;
`;

export const InnerContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 0 1rem 1rem 1rem;

  ${media.mediumDesktop`
    padding-bottom: 0.5rem
  `}
`;

export const Image = styled.img`
  width: 100%;
  height: 4rem;
  object-fit: cover;
`;

export const EventName = styled.div`
  font-weight: 800;
  ${media.mediumDesktop`
    display: none;
  `}
`;
export const EventHeading = styled.div`
  font-size: 1.75rem;
  font-weight: 800;
`;
export const Heading = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: 0.5rem;
  ${media.mediumDesktop`
    display: none;
  `}
`;
export const Name = styled.div`
  font-weight: 700;
  font-size: ${({ $bigHeader }) => ($bigHeader ? '1.75rem' : 'initial')};
`;
export const PurchaseInfo = styled.div`
  display: flex;
  justify-content: space-between;

  ${({ $hideOnSmallScreen }) =>
    $hideOnSmallScreen &&
    css`
      @media (max-width: ${breakpoints.mediumDesktop}) {
        display: none;
      }
    `}
`;

export const Amount = styled.div`
  color: ${colors.pacificBlue};
`;

export const Price = styled.div`
  color: ${colors.pacificBlue};
`;

export const TicketCode = styled.div`
  border-top: 0.5px solid ${colors.gallery};
  padding-top: 0.5rem;
`;

export const Divider = styled.div`
  border-bottom: 1px solid ${colors.gallery};

  ${media.mediumDesktop`
    display: none;
  `}
`;
